export function getUrlParams(params) {
  const v = window.location.search.match(
    new RegExp(`(?:[?&]${params}=)([^&]+)`),
  );
  return v ? v[1] : undefined;
}

export function getParamsUrlString(url, params) {
  const v = url && url.match(new RegExp(`(?:[?&]${params}=)([^&]+)`));
  return v ? v[1] : undefined;
}

export function getUrlArray() {
  return window.location.pathname.split("/");
}

// export function bindUrlWithParams(url, queryParams = '') {
//   let relativePath = '';
//   if (url === '') {
//     // Get current relative path
//     relativePath = `/${getUrlArray()[1]}`;
//   } else {
//     relativePath = url;
//   }

//   // Build whitelisted params
//   const urlString = window.location.href;
//   const urlFull = new URL(urlString);
//   const hmac = urlFull.searchParams.get('hmac');
//   const locale = urlFull.searchParams.get('locale');
//   const session = urlFull.searchParams.get('session');
//   const shop = urlFull.searchParams.get('shop');
//   const timestamp = urlFull.searchParams.get('timestamp');
//   const newDesignLanguage = urlFull.searchParams.get('new_design_language');

//   let defaultUrl = `${relativePath}?hmac=${hmac}&locale=${locale}&new_design_language=${newDesignLanguage}&session=${session}&shop=${shop}&timestamp=${timestamp}`;
//   const env = process.env.REACT_APP_ENV;
//   if (env === 'local') {
//     defaultUrl += '&not-redirect=1';
//   }
//   const darkmode = document.querySelector('.ak-darkmode');
//   document.querySelector('.container-fluid').classList.remove('Ak-Overview');
//   if (darkmode) {
//     document.querySelector('.ak-darkmode').style.display = 'none';
//   }
//   return `${defaultUrl}${queryParams}`;
// }

export function bindUrlWithParams(url, queryParams = "") {
  let relativePath = "";
  if (url === "") {
    // Get current relative path
    relativePath = `/${getUrlArray()[1]}`;
  } else {
    relativePath = url;
  }

  // Build whitelisted params
  const urlString = window.location.href;
  const urlFull = new URL(urlString);
  const hmac = urlFull.searchParams.get("hmac");
  const locale = urlFull.searchParams.get("locale");
  const session = urlFull.searchParams.get("session");
  const shop = urlFull.searchParams.get("shop");
  const timestamp = urlFull.searchParams.get("timestamp");
  const newDesignLanguage = urlFull.searchParams.get("new_design_language");

  let defaultUrl = `${relativePath}?hmac=${hmac}&locale=${locale}&new_design_language=${newDesignLanguage}&session=${session}&shop=${shop}&timestamp=${timestamp}`;
  const env = process.env.REACT_APP_ENV;
  if (env === "local") {
    defaultUrl += "&not-redirect=1";
  }
  const darkmode = document.querySelector(".ak-darkmode");
  if (darkmode) {
    document.querySelector(".ak-darkmode").style.display = "none";
  }
  return `${defaultUrl}${queryParams}`;
}

function validateExists(id, mainItems) {
  const items = mainItems || [];
  let found = false;
  // Kiểm tra có bị trùng item không
  items.forEach((item) => {
    if (parseInt(item) === parseInt(id)) {
      found = true;
    }
  });
  return found;
}

export function customFieldProduct(items, mainItems) {
  const mainItemToJs = mainItems ? mainItems.toJS() : [];
  for (let i = 0; i < items.length; i++) {
    // const defaultImage = item.images[0] ? item.images[0].originalSrc : '';
    const id = items[i].id;
    // const variants = item.variants;
    const newId = id.substr(id.lastIndexOf("/") + 1);
    const isExists = validateExists(newId, mainItems);
    if (!isExists) {
      mainItemToJs.unshift(parseInt(newId));
    }
  }
  return mainItemToJs;
}

export function customFieldCollection(items, mainItems) {
  const mainItemToJs = mainItems ? mainItems.toJS() : [];
  items.forEach(async (item) => {
    const id = item.id;
    const newId = id.substr(id.lastIndexOf("/") + 1);
    const isExists = validateExists(newId, mainItems);
    if (!isExists) {
      mainItemToJs.unshift(parseInt(newId));
    }
  });
  return mainItemToJs;
}
// log

export function timeAgo(date) {
  const dates = new Date(date).getTime();
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  const year = day * 365;

  const suffix = " ago";

  const elapsed = Math.floor((Date.now() - dates) / 1000);

  if (elapsed < minute) {
    return "just now";
  }

  // get an array in the form of [number, string]
  const a = (elapsed < hour && [Math.floor(elapsed / minute), "minute"]) ||
    (elapsed < day && [Math.floor(elapsed / hour), "hour"]) ||
    (elapsed < month && [Math.floor(elapsed / day), "day"]) ||
    (elapsed < year && [Math.floor(elapsed / month), "month"]) || [
      Math.floor(elapsed / year),
      "year",
    ];

  // pluralise and append suffix
  return `${a[0]} ${a[1]}${a[0] === 1 ? "" : "s"} ${suffix}`;
}

export function getDateBefore(date, number) {
  const dates = new Date(date).getTime();
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;

  const dateBefore = new Date(dates - number * day * 1000);

  let timeStart;
  let timeEnd;

  if (dateBefore.getMonth() + 1 < 10) {
    timeStart = `${dateBefore.getFullYear()}-0${
      dateBefore.getMonth() + 1
    }-${dateBefore.getDate() < 10 ? "0" : ""}${dateBefore.getDate()}`;
  } else {
    timeStart = `${dateBefore.getFullYear()}-${dateBefore.getMonth() + 1}-${
      dateBefore.getDate() < 10 ? "0" : ""
    }${dateBefore.getDate()}`;
  }

  if (date.getMonth() + 1 < 10) {
    timeEnd = `${date.getFullYear()}-0${date.getMonth() + 1}-${
      date.getDate() < 10 ? "0" : ""
    }${date.getDate()}`;
  } else {
    timeEnd = `${date.getFullYear()}-${date.getMonth() + 1}-${
      date.getDate() < 10 ? "0" : ""
    }${date.getDate()}`;
  }

  const data = {
    now: `${timeEnd}`,
    before: `${timeStart}`,
  };

  return data;
}

export function formatDate(dates) {
  const newDate = dates || [];
  const data = newDate.map((date) => {
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
    }).format(new Date(date));
  });

  return data;
}

export function formatMonth(dates = []) {
  const newDate = dates || [];
  const data = newDate.map((date) => {
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
    }).format(new Date(date));
  });

  return data;
}

export function getImageResize(url, size = "") {
  const pos = url.lastIndexOf(".");
  const length = url.length;
  const firstString = url.substr(0, pos);
  const lastString = url.substr(pos, length - pos);
  const data = firstString + size + lastString;

  return data;
}
